import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Filter, Sliders } from "react-feather";
import Select from "react-select";
import { Globe, User } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ImageWithBasePath from "../../img/imagewithbasebath";
import StoreModal from "./storeModal";
import { API_BASE_URL, GET_STORE } from "../../../Config";
import Axios from "axios";
import {
  ChevronUp,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setstorelist_data, setToogleHeader } from "../../redux/action";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const StoreList = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.storelist_data) || [];
  const data = useSelector((state) => state.toggle_header);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [editStoreObj, setEditStoreObj] = useState([]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            dispatch(setstorelist_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.Name &&
        item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.StoreCode &&
        item.StoreCode.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.City &&
        item.City.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.State &&
        item.State.toLowerCase().includes(searchQuery.toLowerCase()))
    // (item.Qty && item.Qty.toString().includes(searchQuery.toLowerCase()))
  );

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource?.map((item) => ({
      "Store Name": item.Name,
      "Store Code": item.Code,
      "Created Date": item.CreatedOn,
      Dscription: item.Description,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "StoreData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "StoreData.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Name", "Code", "Description", "Created Date"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(item.Name, item.Code, item.Description, item.CreatedOn);
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("CategoryDatta.pdf");
  };

  const showEditModal = (storeObj) => {
    setEditStoreObj(storeObj);
  };

  const showViewModal = (storeObj) => {
    setEditStoreObj(storeObj);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];
  const optionsTwo = [
    { label: "Choose Store Name", value: "" },
    { label: "Benjamin", value: "Benjamin" },
    { label: "Ellen", value: "Ellen" },
    { label: "Freda", value: "Freda" },
    { label: "Kaitlin", value: "Kaitlin" },
  ];

  const countries = [
    { label: "Choose Country", value: "" },
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
  ];

  const columns = [
    // {
    //   render: () => (
    //     <label className="checkboxs">
    //       <input type="checkbox" />
    //       <span className="checkmarks" />
    //     </label>
    //   ),
    // },

    {
      title: "S.No",  // Serial number column
      render: (text, record, index) => index + 1,
    },

    {
      title: "Store Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.length - b.Name.length,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: "GSTIN",
      dataIndex: "GSTIN",
      sorter: (a, b) => a.GSTIN.length - b.GSTIN.length,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: "StoreCode",
      dataIndex: "StoreCode",
      sorter: (a, b) => a.StoreCode.length - b.StoreCode.length,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: "State",
      dataIndex: "State",
      sorter: (a, b) => a.State.length - b.State.length,
      render: (text) => text ? text : 'N/A',
    },
    {
      title: "City",
      dataIndex: "City",
      sorter: (a, b) => a.City.length - b.City.length,
      render: (text) => text ? text : 'N/A',
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td>
          <div className="edit-delete-action">
            <Link
              to="#"
              className="dropdown-oggle nav-lik selet-store"
              data-bs-toggle="dropdown"
            >
              <i className="fa-solid fa-ellipsis-vertical btn border"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link
                to="#"
                className="dropdown-item ms-3 mb-3 mt-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightViewStore"
                aria-controls="offcanvasRightViewStore"
                onClick={() => showViewModal(record)}
              >
                <i className="fa-regular fa-eye me-2 text-primary"></i>
                View
              </Link>
              <Link
                to="#"
                className="dropdown-item ms-3 mb-3 mt-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightEditStore"
                aria-controls="offcanvasRightEditStore"
                onClick={() => showEditModal(record)}
              >
                <i className="fa-regular fa-pen-to-square me-2 text-info"></i>
                Edit
              </Link>
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-3 conform-text`}
                onClick={() => showConfirmationAlert(record.Id)}
              >
                <i
                  data-feather="trash-2"
                  className="feather-trash-2 me-2 text-danger"
                ></i>
                Delete
              </Link>
            </div>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stores</h4>
              <h6>Manage your stores</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li onClick={generatePDF}>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li onClick={handleDownloadExcel}>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="#"
              className="btn btn-added"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightAddStore"
              aria-controls="offcanvasRightAddStore"
            >
              <PlusCircle className="me-2" />
              Add
            </Link>
          </div>
        </div>

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              <div className="form-sort stylewidth">
                <Sliders className="info-img" />

                <Select
                  className="select "
                  options={options}
                  placeholder="Sort by Date"
                />
              </div>
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="row">
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <User className="info-img" />
                      <Select
                        options={optionsTwo}
                        placeholder="Choose Store Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12">
                    <div className="input-blocks">
                      <Globe className="info-img" />
                      <Select
                        options={countries}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                    <div className="input-blocks">
                      <a className="btn btn-filters ms-auto">
                        {" "}
                        <i
                          data-feather="search"
                          className="feather-search"
                        />{" "}
                        Search{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Filter */}
            <div className="table-responsive">
              {loading ? (
                // <div className="loader m-auto"></div>
                <SpinLoader/>
              ) : (
                <Table columns={columns} dataSource={filteredData} />
              )}
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <StoreModal storeObj={editStoreObj} />
    </div>
  );
};

export default StoreList;
